// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1r1n8","alertIcon":"ConfirmModal_alertIcon__1jNtC"};